




































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({ })
export default class AppBarComponent extends Vue {
	public get user() {
		return this.$store.getters['user/getUser'];
	}

	public get isAdmin() {
		return this.$store.getters['user/getIsAdmin'];
	}
	public get isManager() {
		return this.$store.getters['user/getIsManager'];
	}
	public get isTester() {
		return this.$store.getters['user/getIsTester'];
	}

	public async logOut() {
		await this.$store.dispatch('user/logout');
	}
}
